export enum FormType {
    ACTIVITY = 'activity',
    BENEFIT = 'benefit',
    FLIGHT = 'flight',
    HOTEL = 'hotel',
    CAR = 'car'
}